import { watch } from 'vue'
import { useRouter } from 'vue-router'
import { i18n } from '@/i18n'
import { applyDocumentTitle } from '@/i18n/documentTitle'
import { useEffectiveLocale } from '@/composables/useEffectiveLocale'

/**
 * ADR-010 D3: applies the derived effective locale to `vue-i18n`, `<html lang>` and the page title;
 * the only writer of the active locale. The account preferences themselves are loaded by the auth
 * store (it already fetches the Kora account) and cleared there on sign-out.
 */
export function useLocaleSync(): void {
  const { effectiveLocale } = useEffectiveLocale()
  const router = useRouter()

  // `watch`, not `watchEffect`: vue-i18n's locale setter reads its own state, which an effect
  // would track and re-trigger on.
  watch(
    effectiveLocale,
    locale => {
      i18n.global.locale.value = locale
      document.documentElement.lang = locale
      applyDocumentTitle(router.currentRoute.value)
    },
    { immediate: true }
  )
}
